import React, { useCallback, useContext, useEffect, useMemo, } from 'react'
import { Prorate } from './prorate'
import CostType from './costType'
import DefaultValues from './defaultValues'
import { ProrateWeight } from './prorateWeight'
import { Form } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import { prorateCostType, saveCostTypeField, updateCostType } from '../commonValueBuildUpTab/actions/ValueBuildUp'
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType'
import Parties from './parties'
import ValueIndicator from './ValueIndicator'
import { ValueBuildUpContext } from './ValueBuildUpContext'
import EuParties from './parties/EuParties'

export default function ValueBuildUpTab({
  ActorDetailForm,
  translate,
  invoices=[],
  incoTerm,
  invoiceAmount,
  isDisabled,
  isNLAPP,
  isDMS,
  DropDownReducer,
  isImportShipment,
  actorDetailsAndActions,
  buyer,
  seller,
  procedure,
  ...rest
}) {
  const dispatch = useDispatch()
  const { updateItemTab } = useContext(ValueBuildUpContext)
  const { serviceType } = useCurrentShipmentType()
  let INVCostType =
    useSelector((state) =>
      state.ValueBuildUpReducer?.shipmentCostType?.find((costs) => costs.costType === 'INV')
    ) || []
  const incoterm = invoices[0]?.incoTermsConditionsCode || incoTerm
  let shipmentType = serviceType === 'IM' ? 'IMPORT' : 'EXPORT'

  const prorateOnclick = useCallback(
    (updateProrateStatus) => {
      let payload = { shipmentType, incoterm }
      dispatch(prorateCostType(payload, updateProrateStatus, updateItemTab))
    },
    [shipmentType, incoterm]
  )

  useEffect(() => {
    INVCostType?.costTypeId &&
      (dispatch(
        updateCostType(INVCostType?.costTypeId, {
          amount: invoiceAmount,
          currency: 'EUR',
          exchangeRate: '1.00000000',
          euroValue: invoiceAmount,
        })
      ),
      dispatch(
        saveCostTypeField(INVCostType?.costTypeId, [
          'amount',
          'currency',
          'exchangeRate',
          'euroValue',
        ])
      ))
  }, [invoiceAmount, INVCostType?.costTypeId])
  return (
    <div className='formContentareaC88 headerDetails valueBuildUp'>
      <Form.Group className='float-container actor'>
        <Prorate translate={translate} invoiceAmount={invoiceAmount}></Prorate>
        <CostType
          {...rest}
          translate={translate}
          prorateOnclick={prorateOnclick}
          DropDownReducer={DropDownReducer}
        ></CostType>
        <DefaultValues translate={translate}></DefaultValues>
        <ProrateWeight translate={translate}></ProrateWeight>
        {(!isNLAPP && isImportShipment) && (
          <Parties
            translate={translate}
            buyers={Array.isArray(buyer) ? buyer : [buyer]}
            sellers={Array.isArray(seller) ? seller : [seller]}
            actorDetailsAndActions={actorDetailsAndActions}
            isNLAPP={isNLAPP}
          />
        )}
        {(isNLAPP && isDMS && isImportShipment && ['H1', 'I1'].includes(procedure))&&(
          <EuParties
            translate={translate}
            buyers={buyer}
            sellers={seller}
          />
        )}
        {((!isNLAPP && isImportShipment) ||
          (isNLAPP &&
            isDMS &&
            isImportShipment &&
            ['H1', 'H4', 'H5', 'I1'].includes(procedure))) && (
          <ValueIndicator translate={translate} isDisabled={isDisabled} />
        )}
      </Form.Group>
    </div>
  )
}
